import { render, staticRenderFns } from "./TrayVariantsTooltip.vue?vue&type=template&id=2a699154"
import script from "./TrayVariantsTooltip.vue?vue&type=script&lang=js"
export * from "./TrayVariantsTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports